import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LeedService } from 'src/app/service/leed.service';
import { Helper } from 'src/app/shared/Helper';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-admin-leeds',
  templateUrl: './admin-leeds.component.html',
  styleUrls: ['./admin-leeds.component.css']
})
export class AdminLeedsComponent implements OnInit {
  carregando = false;
  carregandoHistorico = false;
  exportando = false;
  erro = '';

  filtros: any = {
    usuarioFk: '',
    regiaoFk: '',
    status: '',
    estado: ''
  };
  filtrosAplicados: any = {
    usuarioFk: '',
    regiaoFk: '',
    status: '',
    estado: ''
  };

  distribuidores: any[] = [];
  regioes: any[] = [];
  statusDisponiveis: string[] = [];
  estados: string[] = [];

  leeds: any[] = [];
  totaisStatus: any[] = [];
  totalLeedsFiltrados = 0;

  historicoLead: any[] = [];
  tentativasHistorico: any[] = [];
  leadHistoricoSelecionado: any = null;
  modalTransferenciaAberto = false;
  modalTransferenciaCarregando = false;
  modalTransferenciaFiltro = '';
  modalTransferenciaDistribuidores: any[] = [];
  modalTransferenciaSelecionadoId = '';
  leedTransferenciaSelecionado: any = null;
  colunaOrdenacao = 'dataCadastro';
  direcaoOrdenacao: 'asc' | 'desc' = 'desc';

  constructor(private leedService: LeedService, private router: Router) { }

  ngOnInit() {
    this.carregarDadosIniciais();
  }

  carregarDadosIniciais() {
    this.carregando = true;
    this.erro = '';

    this.leedService.getGerenciamentoDistribuidores().subscribe((res: any) => {
      this.distribuidores = res && res.itens ? res.itens : [];
      this.carregarLeeds();
    }, () => {
      this.distribuidores = [];
      this.carregarLeeds();
    });
  }

  carregarLeeds() {
    this.carregando = true;
    this.erro = '';

    const filtrosConsulta = Object.assign({}, this.filtros);
    this.leedService.getGerenciamentoLeeds(filtrosConsulta).subscribe((res: any) => {
      this.carregando = false;
      if (res && res.sucesso) {
        this.filtrosAplicados = filtrosConsulta;
        this.leeds = res.itens || [];
        this.aplicarOrdenacaoAtual();
        this.totaisStatus = res.totaisStatus || [];
        this.totalLeedsFiltrados = res.totalLeedsFiltrados || 0;

        const filtrosRetorno = res.filtros || {};
        this.estados = filtrosRetorno.estados || [];
        this.regioes = filtrosRetorno.regioes || [];
        this.statusDisponiveis = filtrosRetorno.status || [];
      } else {
        this.erro = (res && res.msg) ? res.msg : 'Não foi possível carregar os Leeds.';
      }
    }, () => {
      this.carregando = false;
      this.erro = 'Não foi possível carregar os Leeds.';
    });
  }

  aplicarFiltros() {
    this.fecharHistorico();
    this.carregarLeeds();
  }

  limparFiltros() {
    this.filtros = {
      usuarioFk: '',
      regiaoFk: '',
      status: '',
      estado: ''
    };
    this.fecharHistorico();
    this.carregarLeeds();
  }

  exportarExcel() {
    if (this.exportando) {
      return;
    }

    this.exportando = true;
    this.erro = '';

    this.leedService.exportarGerenciamentoLeeds(
      this.filtrosAplicados,
      this.colunaOrdenacao,
      this.direcaoOrdenacao
    ).subscribe((arquivo: Blob) => {
      this.exportando = false;
      saveAs(arquivo, 'leads.xlsx');
    }, () => {
      this.exportando = false;
      this.erro = 'Não foi possível exportar os Leads.';
    });
  }

  verHistorico(lead: any) {
    this.leadHistoricoSelecionado = lead;
    this.historicoLead = [];
    this.carregandoHistorico = true;

    this.leedService.getGerenciamentoHistorico(lead.leedId).subscribe((res: any) => {
      this.carregandoHistorico = false;
      if (res && res.sucesso) {
        this.historicoLead = res.itens || [];
        this.tentativasHistorico = res.tentativas || [];
      } else {
        this.historicoLead = [];
        this.tentativasHistorico = [];
      }
    }, () => {
      this.carregandoHistorico = false;
      this.historicoLead = [];
      this.tentativasHistorico = [];
    });
  }

  fecharHistorico() {
    this.leadHistoricoSelecionado = null;
    this.historicoLead = [];
    this.tentativasHistorico = [];
  }

  abrirModalTransferencia(leed: any) {
    if (!leed || !leed.leedId) {
      return;
    }

    this.erro = '';
    this.leedTransferenciaSelecionado = leed;
    this.modalTransferenciaAberto = true;
    this.modalTransferenciaFiltro = '';
    this.modalTransferenciaSelecionadoId = '';
    this.modalTransferenciaDistribuidores = [];
    this.carregarDistribuidoresDestinoTransferencia();
  }

  fecharModalTransferencia() {
    this.modalTransferenciaAberto = false;
    this.modalTransferenciaCarregando = false;
    this.modalTransferenciaFiltro = '';
    this.modalTransferenciaDistribuidores = [];
    this.modalTransferenciaSelecionadoId = '';
    this.leedTransferenciaSelecionado = null;
  }

  onFiltroTransferenciaChange() {
    this.carregarDistribuidoresDestinoTransferencia();
  }

  selecionarDistribuidorTransferencia(usuarioId: string) {
    this.modalTransferenciaSelecionadoId = usuarioId;
  }

  confirmarTransferenciaLeed() {
    if (!this.leedTransferenciaSelecionado || !this.leedTransferenciaSelecionado.leedId) {
      this.erro = 'Lead inválido para transferência.';
      return;
    }

    if (!this.modalTransferenciaSelecionadoId) {
      this.erro = 'Selecione o distribuidor de destino.';
      return;
    }

    const leedId = this.leedTransferenciaSelecionado.leedId;
    const usuarioDestinoId = this.modalTransferenciaSelecionadoId;
    this.fecharModalTransferencia();
    this.carregando = true;

    this.leedService.transferirGerenciamentoLeed(leedId, usuarioDestinoId).subscribe((res: any) => {
      if (res && res.sucesso) {
        this.carregarLeeds();
      } else {
        this.carregando = false;
        this.erro = (res && res.msg) ? res.msg : 'Não foi possível transferir o lead.';
      }
    }, () => {
      this.carregando = false;
      this.erro = 'Não foi possível transferir o lead.';
    });
  }

  obterTotalStatus(status: string): number {
    const item = (this.totaisStatus || []).find((x: any) => x.status === status);
    return item ? item.total : 0;
  }

  goToHome() {
    Helper.NavToDashboard(this.router, 'Leads');
  }

  ordenarPor(coluna: string) {
    if (this.colunaOrdenacao === coluna) {
      this.direcaoOrdenacao = this.direcaoOrdenacao === 'asc' ? 'desc' : 'asc';
    } else {
      this.colunaOrdenacao = coluna;
      this.direcaoOrdenacao = 'asc';
    }

    this.aplicarOrdenacaoAtual();
  }

  indicadorOrdenacao(coluna: string): string {
    if (this.colunaOrdenacao !== coluna) {
      return '';
    }

    return this.direcaoOrdenacao === 'asc' ? ' ▲' : ' ▼';
  }

  private aplicarOrdenacaoAtual() {
    const coluna = this.colunaOrdenacao;
    const direcao = this.direcaoOrdenacao === 'asc' ? 1 : -1;

    this.leeds = (this.leeds || []).slice().sort((a: any, b: any) => {
      const valorA = this.obterValorOrdenacao(a, coluna);
      const valorB = this.obterValorOrdenacao(b, coluna);

      if (valorA < valorB) {
        return -1 * direcao;
      }

      if (valorA > valorB) {
        return 1 * direcao;
      }

      return 0;
    });
  }

  private obterValorOrdenacao(item: any, coluna: string): any {
    const valor = item && item[coluna] !== undefined && item[coluna] !== null ? item[coluna] : '';

    if (coluna === 'dataCadastro') {
      const data = new Date(valor);
      return isNaN(data.getTime()) ? 0 : data.getTime();
    }

    return ('' + valor).toLowerCase();
  }

  private carregarDistribuidoresDestinoTransferencia() {
    if (!this.leedTransferenciaSelecionado || !this.leedTransferenciaSelecionado.leedId) {
      return;
    }

    this.modalTransferenciaCarregando = true;
    this.leedService.getGerenciamentoDistribuidoresDestino(
      this.leedTransferenciaSelecionado.leedId,
      this.modalTransferenciaFiltro
    ).subscribe((res: any) => {
      this.modalTransferenciaCarregando = false;
      if (res && res.sucesso) {
        this.modalTransferenciaDistribuidores = res.itens || [];
      } else {
        this.modalTransferenciaDistribuidores = [];
      }
    }, () => {
      this.modalTransferenciaCarregando = false;
      this.modalTransferenciaDistribuidores = [];
    });
  }
}
